// 距离保护单位切换与馈线联动的可测试逻辑提取

// 根据每公里参数与长度计算总阻抗，模式为 per_km 时返回需要更新的字段
export function computeTotalsFromPerKm({ mode, lineLength_km, lineR_per_km_ohm, lineX_per_km_ohm }) {
  const result = {};
  if ((mode || 'total') !== 'per_km') return result;
  const L = Number(lineLength_km);
  const Rpkm = Number(lineR_per_km_ohm);
  const Xpkm = Number(lineX_per_km_ohm);
  if (isFinite(L) && isFinite(Rpkm)) result.lineR_ohm = parseFloat(((Rpkm || 0) * (L || 0)).toFixed(4));
  if (isFinite(L) && isFinite(Xpkm)) result.lineX_ohm = parseFloat(((Xpkm || 0) * (L || 0)).toFixed(4));
  return result;
}

// 基于馈线对象预填距离保护相关参数（每公里R/X与长度），并计算总阻抗
export function applyFeederPresetToDistance(feeder) {
  const Rpkm = feeder?.line?.R_per_km_ohm ?? feeder?.R_per_km_ohm;
  const Xpkm = feeder?.line?.X_per_km_ohm ?? feeder?.X_per_km_ohm;
  const Lkm = feeder?.line?.length_km ?? feeder?.length_km;
  const R = (typeof Rpkm === 'number' && typeof Lkm === 'number') ? (Rpkm * Lkm) : undefined;
  const X = (typeof Xpkm === 'number' && typeof Lkm === 'number') ? (Xpkm * Lkm) : undefined;
  const patch = {
    lineImpedanceUnitMode: 'per_km',
    lineLength_km: Lkm,
    lineR_per_km_ohm: Rpkm,
    lineX_per_km_ohm: Xpkm,
    lineR_ohm: (typeof R === 'number' && isFinite(R)) ? parseFloat(R.toFixed(4)) : undefined,
    lineX_ohm: (typeof X === 'number' && isFinite(X)) ? parseFloat(X.toFixed(4)) : undefined,
  };
  return patch;
}